export const getStreamsMap = (streams, value) => streams.reduce((acc, stream) => {
    acc[stream.id] = value || null;
    return acc;
}, {});

export const flattenMessages = (messages) => {
    const result = [];

    if (Array.isArray(messages)) {
        messages.forEach(message => {
            result.push(message);
    
            if (message.children) {
                const children = flattenMessages(message.children);
                result.push(...children);
            }
        });
    }

    return result;
}

export const updateMessages = (messages, data) => (messages || []).map(message => ({...message, ...(data || {}), children: updateMessages(message.children, data)}));

export const deleteMessages = (messages, messageID) => (messages || []).filter(({id}) => id !== messageID).map(msg => ({...msg, children: (msg.children || []).filter(({id}) => id !== messageID)}));

export const getMsgClientId = (message) => {
    if (!message) return null;
    return  message.clientRegistration?.id ?? message.client?.id;
}